import { createFileRoute } from '@tanstack/react-router'

import { BoardNotFoundState } from '@/pages/board-page'

export const Route = createFileRoute('/')({
    component: () => <BoardNotFoundState variant='invalid-link' />,
})
